const Images = {
    Logo: "/assets/img/Logo.svg",
    headerLogo: "/assets/img/Logo.svg",
};

export default Images;
